import clsx from "clsx";

const TONES = {
  accent: "bg-surface-alt text-accent-solid",
  muted: "bg-surface-alt text-text-muted",
  fresh: "bg-success-bg text-success-ink",
  warn: "bg-warn-bg text-warn",
  danger: "bg-danger-bg text-danger",
};

// `md` is the planner mock's `.badge` (11 px, a border in the tone); the default stays the 10 px badge of the sync screens.
const BORDERS = { warn: "border-warn-border", danger: "border-danger-border" };

function Badge({ tone = "muted", size = "sm", children, className, ...rest }) {
  return (
    <span
      data-tone={tone}
      className={clsx(
        "inline-flex items-center rounded-full px-2 py-0.5 font-semibold whitespace-nowrap",
        size === "md" ? clsx("gap-1 border text-[11px] leading-[1.5]", BORDERS[tone] || "border-transparent") : "text-[10px]",
        TONES[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}

export default Badge;
